import React from "react";
import { FiX } from "react-icons/fi";

export default function CrudModal({
  open,
  title,
  children,
  loading = false,
  submitText = "Save",
  width = "max-w-5xl",
  isEditMode = false,
  onClose,
  onSubmit,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">

      <div
        className={`relative mx-4 flex max-h-[90vh] w-full flex-col overflow-hidden rounded-2xl bg-white shadow-2xl ${width}`}
      >
        {/* Header */}

        <div className="flex items-center justify-between border-b px-6 py-5">

          <h2 className="text-xl font-bold text-navy-700">
            title={isEditMode ? "Edit Visit" : "Create Visit"}
          </h2>

          <button
            onClick={onClose}
            className="rounded-lg p-2 transition hover:bg-gray-100"
          >
            <FiX size={22} />
          </button>

        </div>

        {/* Body */}

        <form
          onSubmit={onSubmit}
          className="flex flex-1 flex-col overflow-hidden"
        >
          <div className="flex-1 overflow-y-auto px-6 py-6">

            {children}

          </div>

          {/* Footer */}

          <div className="flex items-center justify-end gap-3 border-t bg-gray-50 px-6 py-4">

            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-gray-300 bg-white px-5 py-2.5 font-medium text-gray-700 transition hover:bg-gray-100"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="rounded-lg bg-brand-500 px-6 py-2.5 font-medium text-white transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {loading ? "Saving..." : submitText}
            </button>

          </div>

        </form>

      </div>

    </div>
  );
}